import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarMenuSkeletonProps from "./type";
import stylesheet, {
    SIDEBAR_SKELETON_WIDTHS,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import {
    useSidebarRootContext
} from "../../context";
import {
    getSidebarRowMeasures,
    getSidebarMeasures
} from "../../stylesheet";
import Skeleton from "../../../skeleton";

const SidebarMenuSkeleton: FC<ISidebarMenuSkeletonProps> = ({
    customLocalize: customLocalizeProp,
    customTheme: customThemeProp,
    isShowIcon = true,
    size = "medium",
    count = 5,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.MenuSkeleton"
    });

    const customLocalize = customLocalizeProp ?? root?.customLocalize;

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        touchTargets,
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const pointerType = usePointerType();

    const isCollapsed = root?.isCollapsed ?? false;

    const measures = getSidebarMeasures({
        controlPaddings,
        controlHeights,
        shapeConfigs,
        spaces
    });

    const rowMeasures = getSidebarRowMeasures({
        square: measures.square,
        controlHeights,
        touchTargets,
        pointerType,
        iconSizes,
        size
    });

    const {
        container: containerDynamicStyle,
        row: rowDynamicStyle
    } = useStyles({
        rowMeasures,
        measures,
        spaces
    });

    const renderRows = () => {
        return Array.from({
            length: count
        }, (_, index) => <View
            style={[
                stylesheet.row,
                rowDynamicStyle
            ]}
            key={index}
        >
            {
                (isShowIcon || isCollapsed) && <Skeleton
                    size={rowMeasures.iconSize}
                    customTheme={customTheme}
                    variant="icon"
                />
            }
            {
                !isCollapsed && <View
                    style={stylesheet.text}
                >
                    <Skeleton
                        width={SIDEBAR_SKELETON_WIDTHS[index % SIDEBAR_SKELETON_WIDTHS.length]}
                        typography={rowMeasures.labelVariant}
                        customTheme={customTheme}
                        variant="text"
                    />
                </View>
            }
        </View>);
    };

    return <Skeleton.Group
        {...props}
        customLocalize={customLocalize}
        placeholder={renderRows()}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        customTheme={customTheme}
        isLoading={true}
    />;
};
export default SidebarMenuSkeleton;
